import React from 'react';
import { Box, Heading, Link, Text, Icon } from '@chakra-ui/react';
import { FiExternalLink } from 'react-icons/fi';
import config from '../../../config';

export const Info: React.FC = () => (
  <Box p="4" layerStyle="base">
    <Heading variant="section">Need help? 🙋</Heading>
    <Box mt="4">
      <Text fontWeight="bold">Online Support Page 👩‍💻</Text>
      <Link
        href={`${config.landingPageUrl}/support`}
        isExternal
        color="brand.blue"
      >
        User Guide and How To&apos;s <Icon as={FiExternalLink} mx="2px" />
      </Link>
    </Box>
    <Box mt="4">
      <Text fontWeight="bold">Address 🏠</Text>
      <Text>55 Pyrmont Bridge Rd, Pyrmont NSW 2009</Text>
    </Box>
  </Box>
);
